import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=4279f129&"
import script from "./recommend.vue?vue&type=script&lang=js&"
export * from "./recommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4279f129')) {
      api.createRecord('4279f129', component.options)
    } else {
      api.reload('4279f129', component.options)
    }
    module.hot.accept("./recommend.vue?vue&type=template&id=4279f129&", function () {
      api.rerender('4279f129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/recommend.vue"
export default component.exports